export function getIsLoggedIn(state){
    return !!state.auth.bsrsToken
}

export function getIsLoggedInO365(state){
    return !!state.auth.token.access_token
}

export function getUserInfo(state){
    return state.auth.user
}

export function getUserEmail(state){
    return state.auth.user.email
}

export function getSettings(state, props) {
    return state.settings
}



// WEBPACK FOOTER //
// ./src/features/auth/selectors.js